class ThemeGa4 extends window.BAO.CustomElement() {
  setupListeners() {
    super.setupListeners();

    this.trackCartChanged = this.trackCartChanged.bind(this);
    this.trackAddToCart = this.trackAddToCart.bind(this);
    this.trackRemoveFromCart = this.trackRemoveFromCart.bind(this);

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.trackCartChanged,
    );
  }

  trackCartChanged(event) {
    const eventDetailState = event.detail.state;

    if (eventDetailState.items_added?.length > 0) {
      this.trackAddToCart(eventDetailState.items_added);
    } else if (eventDetailState.items_removed?.length > 0) {
      this.trackRemoveFromCart(eventDetailState.items_removed);
    } else if (eventDetailState.items?.length > 0) {
      this.trackAddToCart(eventDetailState.items);
    } else {
      this.trackAddToCart(eventDetailState);
    }
  }

  trackAddToCart(items) {
    if (Array.isArray(items)) {
      items.forEach((item) => {
        const productId = `${item.product_id}`;
        const productTitle = item.product_title
          ? `${item.product_title}`
          : `${item.untranslated_product_title}`;
        const productBrand = `${item.vendor}`;
        const productVariant = item.variant_title
          ? `${item.variant_title}`
          : item.untranslated_variant_title
            ? `${item.untranslated_variant_title}`
            : "";
        const productPrice = item.original_line_price
          ? `${item.original_line_price / 100.0}`
          : `${item.price}`;
        const productQuantity = `${item.quantity}`;

        window.dataLayer.push({
          event: "add_to_cart",
          cartUpdated: {
            items: [
              {
                item_id: productId,
                item_name: productTitle,
                currency: this.dataset.currency,
                item_brand: productBrand,
                item_variant: productVariant,
                price: productPrice,
                quantity: productQuantity,
              },
            ],
          },
        });
      });
    } else {
      const productId = `${items.product_id}`;
      const productTitle = `${items.product_title}`;
      const productBrand = `${items.vendor}`;
      const productVariant = items.variant_title
        ? `${items.variant_title}`
        : "";
      const productPrice = `${items.original_line_price / 100.0}`;
      const productQuantity = `${items.quantity}`;

      window.dataLayer.push({
        event: "add_to_cart",
        cartUpdated: {
          items: [
            {
              item_id: productId,
              item_name: productTitle,
              currency: this.dataset.currency,
              item_brand: productBrand,
              item_variant: productVariant,
              price: productPrice,
              quantity: productQuantity,
            },
          ],
        },
      });
    }
  }

  trackRemoveFromCart(items) {
    items.forEach((item) => {
      const productId = `${item.product_id}`;
      const productTitle = `${item.title}`;
      const productBrand = `${item.vendor}`;
      const productVariant = item.untranslated_variant_title
        ? `${item.untranslated_variant_title}`
        : "";
      const productPrice = `${item.price}`;
      const productQuantity = `${item.quantity}`;

      window.dataLayer.push({
        event: "remove_from_cart",
        cartUpdated: {
          items: [
            {
              item_id: productId,
              item_name: productTitle,
              currency: this.dataset.currency,
              item_brand: productBrand,
              item_variant: productVariant,
              price: productPrice,
              quantity: productQuantity,
            },
          ],
        },
      });
    });
  }
}

if (!customElements.get("theme-ga4")) {
  customElements.define("theme-ga4", ThemeGa4);
}
